import { save, load } from "redux-localstorage-simple"
import { LOCAL_STORAGE, LOCAL_STORAGE_VERSION } from "./StorageEngineKeys";

export const stateFilters = [
    "home.menuItems",
    "home.currentPage",
    "repertoire.resultsPerPage",
    "repertoire.productMaintenanceSubmissionConfig",
    "repertoire.defaultActiveAccordions",
    "repertoire.matchingSourceTreeData",
    "usage.resultsPerPage",
    "dataIngestion.distributions",
    "dataIngestion.formats",
    "dataIngestion.sources",
    "dataIngestion.destinations",
    "membersPortal.resultsPerPage",
    "membersPortal.defaultActiveAccordions",
];

const localStorageVersion: number = 376;
const existingVersion: number = Number(localStorage[LOCAL_STORAGE_VERSION]);
if (!existingVersion || existingVersion < localStorageVersion && localStorage) {
    localStorage.removeItem(LOCAL_STORAGE);
    localStorage.setItem(LOCAL_STORAGE_VERSION, localStorageVersion.toString());
}

export const saveStorage = save({ states: stateFilters });
export const loadStorage = store => next => action => {
    load({ states: stateFilters, disableWarnings: true })
    return next(action);
}
